import { render } from "./HorizontalBar.vue?vue&type=template&id=4b16bbd6"
import script from "./HorizontalBar.vue?vue&type=script&lang=js"
export * from "./HorizontalBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/HorizontalBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b16bbd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b16bbd6', __exports__)) {
    api.reload('4b16bbd6', __exports__)
  }
  
  module.hot.accept("./HorizontalBar.vue?vue&type=template&id=4b16bbd6", () => {
    api.rerender('4b16bbd6', render)
  })

}


export default __exports__